import React from 'react'
import { Box, useTheme } from '@mui/material'
import { CashAmount } from '../../../swagger'
import getLocaleCurrencyForAmount from '../../../utils/getLocaleCurrencyForAmount'
import FinancialAmount from './common/FinancialAmount'
import FinancialLabel from './common/FinancialLabel'

interface SummaryItemProps {
  label: string
  value: CashAmount
}

const SummaryItem: React.FC<SummaryItemProps> = ({ label, value }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        },
      }}
    >
      <FinancialLabel
        sx={{
          [theme.breakpoints.down('sm')]: {
            whiteSpace: 'nowrap',
          },
        }}
      >
        {label}
      </FinancialLabel>
      <FinancialAmount>
        {getLocaleCurrencyForAmount(value.amount, value.currencyCode)}
      </FinancialAmount>
    </Box>
  )
}

export default SummaryItem
